(function () {
    try {
        const theme = localStorage.getItem('nv-theme') ||
                      (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
        const root = document.documentElement;
        root.setAttribute('data-theme', theme);
        root.setAttribute('data-bs-theme', theme);
    } catch (e) {}
})();

window.nvToggleTheme = function () {
    const root = document.documentElement;
    const next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    root.setAttribute('data-bs-theme', next);
    try { localStorage.setItem('nv-theme', next); } catch (e) {}
};

function selectBehavior() {
    document.querySelectorAll('.select-selected').forEach(el => el.remove());
    document.querySelectorAll('.select-items').forEach(el => el.remove());

    for (const container of document.querySelectorAll('.custom-select')) {
        const select = container.querySelector('select');
        if (!select) continue;

        const tempDiv = document.createElement('div');
        tempDiv.style.cssText = 'visibility:hidden;position:absolute;left:-9999px;display:flex';
        tempDiv.className = 'select-items';
        for (const option of select.options) {
            const item = document.createElement('div');
            item.textContent = option.textContent;
            tempDiv.appendChild(item);
        }
        document.body.appendChild(tempDiv);

        let maxWidth = 0;
        for (const child of tempDiv.children) {
            maxWidth = Math.max(maxWidth, child.offsetWidth + 15);
        }
        document.body.removeChild(tempDiv);

        container.style.minWidth = `${maxWidth}px`;

        let selectedDiv = container.querySelector('.select-selected');
        let itemsDiv = container.querySelector('.select-items');

        if (!selectedDiv) {
            selectedDiv = document.createElement('div');
            selectedDiv.className = 'select-selected';
            selectedDiv.textContent = select.options[select.selectedIndex].textContent;
            container.appendChild(selectedDiv);

            if (!select.disabled) {
                selectedDiv.addEventListener('click', function (e) {
                    e.stopPropagation();
                    closeAllSelect(this);
                    this.nextSibling.classList.toggle('select-hide');
                    this.classList.toggle('select-arrow-active');
                });
            }
        }

        if (!itemsDiv) {
            itemsDiv = document.createElement('div');
            itemsDiv.className = 'select-items select-hide';
            for (const option of select.options) {
                const item = document.createElement('div');
                item.textContent = option.textContent;
                item.addEventListener('click', function () {
                    const sel = this.parentNode.parentNode.querySelector('select');
                    const header = this.parentNode.previousSibling;
                    for (let k = 0; k < sel.length; k++) {
                        if (sel.options[k].textContent === this.textContent) {
                            sel.selectedIndex = k;
                            header.textContent = this.textContent;
                            sel.dispatchEvent(new Event('change', { bubbles: true }));
                            for (const el of this.parentNode.querySelectorAll('.same-as-selected')) {
                                el.classList.remove('same-as-selected');
                            }
                            this.classList.add('same-as-selected');
                            break;
                        }
                    }
                    header.click();
                });
                itemsDiv.appendChild(item);
            }
            container.appendChild(itemsDiv);
        }
    }

    function closeAllSelect(current) {
        const allItems = document.querySelectorAll('.select-items');
        const allSelected = document.querySelectorAll('.select-selected');
        const skip = new Set();

        allSelected.forEach((el, i) => {
            if (current === el) {
                skip.add(i);
            } else {
                el.classList.remove('select-arrow-active');
            }
        });

        allItems.forEach((el, i) => {
            if (!skip.has(i)) {
                el.classList.add('select-hide');
            }
        });
    }

    document.addEventListener('click', closeAllSelect);
}

function relativeDayOffset(dt, now) {
    const startOfDay = d => new Date(d.getFullYear(), d.getMonth(), d.getDate());
    return Math.round((startOfDay(now) - startOfDay(dt)) / 86400000);
}

function formatLocaleDates() {
    const locale = document.documentElement.lang || undefined;
    const now = new Date();
    document.querySelectorAll('[data-novara-locale-date]').forEach(el => {
        const dt = new Date(el.getAttribute('data-novara-locale-date'));
        if (isNaN(dt)) return;

        el.title = new Intl.DateTimeFormat(locale, { dateStyle: 'full', timeStyle: 'short' }).format(dt);

        // Intl options live under their own data-novara-intl-* prefix so metadata
        // attributes (data-novara-locale-*) can never collide.
        const options = {};
        for (const { name, value } of el.attributes) {
            if (name.startsWith('data-novara-intl-')) {
                const key = name.slice('data-novara-intl-'.length).replace(/-([a-z])/g, (_, c) => c.toUpperCase());
                options[key] = value;
            }
        }

        if (el.hasAttribute('data-novara-locale-relative')) {
            const diffDays = relativeDayOffset(dt, now);
            if (diffDays >= 0 && diffDays < 7) {
                const time = options.timeStyle
                    ? new Intl.DateTimeFormat(locale, { timeStyle: options.timeStyle }).format(dt)
                    : null;
                if (diffDays === 0 && time && !options.dateStyle) {
                    // A "today" prefix on a time-only timestamp is noise.
                    el.textContent = time;
                    return;
                }
                const relative = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' }).format(-diffDays, 'day');
                el.textContent = time ? `${relative}, ${time}` : relative;
                return;
            }
        }

        el.textContent = new Intl.DateTimeFormat(locale, options).format(dt);
    });
}

document.addEventListener('DOMContentLoaded', formatLocaleDates);
document.addEventListener('htmx:afterSwap', formatLocaleDates);
document.addEventListener('htmx:oobAfterSwap', formatLocaleDates);
// Periodically update relative date wording ("today"/"yesterday") so it doesn't go stale.
setInterval(formatLocaleDates, 5 * 60 * 1000);

function closeNavbarMenus(e) {
    const summary = e.target.closest('.nv-navbar__menu > summary, .nv-navbar__submenu > summary');
    const openDetails = document.querySelectorAll(
        '.nv-navbar__menu[open], .nv-navbar__submenu[open]'
    );
    if (summary) {
        const parent = summary.parentElement;
        for (const d of openDetails) {
            if (d !== parent) d.removeAttribute('open');
        }
    } else {
        for (const d of openDetails) {
            if (!d.contains(e.target)) d.removeAttribute('open');
        }
    }
}

document.addEventListener('click', closeNavbarMenus);

const SESSION_DRAFT_DEBOUNCE_MS = 500;

// One entry per bound container; pruned when a container leaves the DOM (htmx swap).
let sessionDrafts = [];

// Keeps the fields listed in data-novara-session-draft-opt-fields in sessionStorage under the
// data-novara-session-draft key.
function bindSessionDrafts() {
    // A swapped-out container still flushes its last keystrokes before it is forgotten.
    sessionDrafts = sessionDrafts.filter(draft => {
        if (draft.container.isConnected) return true;
        draft.flush();
        return false;
    });

    document.querySelectorAll('[data-novara-session-draft]').forEach(container => {
        if (container.dataset.novaraSessionDraftBound) return;
        container.dataset.novaraSessionDraftBound = 'true';

        const key = container.getAttribute('data-novara-session-draft');
        const fields = (container.getAttribute('data-novara-session-draft-opt-fields') || '')
            .split(',')
            .map(id => document.getElementById(id.trim()))
            .filter(el => el);

        try {
            const stored = JSON.parse(sessionStorage.getItem(key) || '{}');
            fields.forEach(el => {
                if (stored[el.id] !== undefined) el.value = stored[el.id];
            });
        } catch (e) {}

        let pending = null;
        const save = () => {
            pending = null;
            try {
                const data = {};
                fields.forEach(el => { data[el.id] = el.value; });
                sessionStorage.setItem(key, JSON.stringify(data));
            } catch (e) {}
        };
        const scheduleSave = () => {
            clearTimeout(pending);
            pending = setTimeout(save, SESSION_DRAFT_DEBOUNCE_MS);
        };
        const flush = () => {
            if (pending === null) return;
            clearTimeout(pending);
            save();
        };
        fields.forEach(el => el.addEventListener('input', scheduleSave));
        sessionDrafts.push({ container, flush });
    });
}

document.addEventListener('DOMContentLoaded', bindSessionDrafts);
document.addEventListener('htmx:afterSwap', bindSessionDrafts);
window.addEventListener('pagehide', () => sessionDrafts.forEach(draft => draft.flush()));
